import { APPVIEWS } from '../constants';

export const DEFAULT_CONTEXT = { 'App Accessed': null };

export const isSphereView = () =>
  DEFAULT_CONTEXT['App Accessed'] === APPVIEWS.SPHERE ||
  DEFAULT_CONTEXT['App Accessed'] === APPVIEWS.HEADOFFICE_OLDNAME;
